import React, { useCallback } from 'react';
import { Box } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import ROUTES from '@/common/routes';
import ActivityLog from '@/modules/ActivityLog';
import { Access, Topbar } from '@/modules/core/components';
import { useBreadcrumbs, useCurrentOrganization, useHistory } from '@/modules/core/hooks';
import { ServicesContainer } from '@/modules/ProcessingDefinition/Services';
import theme from '@/styles/theme';

const ServicesPage = () => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const history = useHistory();
  const goHome = useCallback(() => history.push(ROUTES.HOME), [history]);
  useBreadcrumbs([
    {
      route: ROUTES.PROCESSING_DEFINITION,
      title: 'Processing Definition',
    },
    {
      route: ROUTES.SERVICES,
      title: 'Services',
    },
  ]);

  if (!type) {
    return null;
  }

  return (
    <Access
      accessRequirements={[
        { permission: Permissions.MANAGE_SERVICES },
        { permission: Permissions.SET_UP_PROCESSING_DEFINITION },
      ]}
      accessDeniedAction={goHome}
    >
      <Box height="fit-content" width="100%" margin={{ top: '0px' }} pad={{ bottom: 'spacing72' }}>
        <Box>
          <Topbar isSticky />
          <Box align="center">
            <Box width={theme.defaultContentWidth} gap="spacing24">
              <ServicesContainer isPageMode />
              <ActivityLog title="Activity Log" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Access>
  );
};

export default ServicesPage;
